import template from './retailer-reports-page.html';

class RetailerReportsPageController {}

export default class RetailerReportsPageComponent {
  constructor() {
    this.template = template;
    this.controller = RetailerReportsPageController;
  }
}



// WEBPACK FOOTER //
// ./src/modules/retailer-reports/components/retailer-reports-page/retailer-reports-page-component.js